import { render, staticRenderFns } from "./ChatSideBarSetReply.vue?vue&type=template&id=3f197ce2&scoped=true&"
import script from "./ChatSideBarSetReply.vue?vue&type=script&lang=js&"
export * from "./ChatSideBarSetReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatSideBarSetReply.vue?vue&type=style&index=0&id=3f197ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f197ce2",
  null
  
)

export default component.exports